// import dynamic from "next/dynamic";
// import { useState } from "react";
import styles from "./resultTally.module.scss";
import electionKeys from "@/constants/electionKeys";
import { useRouter } from "next/router";
// import { useWindowSize } from "@/hooks/useIsMobile"; // Adjust the path based on your file structure

const ResultTally = () => {
  const router = useRouter();
  // const [isRegionalTab, setIsRegionalTab] = useState(false);
  const currentPath = router?.asPath?.split("?")[0];
  const showResultTally = electionKeys.showResultTally;
  
  const isResultRoute = currentPath === "/";
//   console.log('the key' , process.env.NEXT_PUBLIC_SHOW_EXIT_POLL)

  return (
    <>{ 
        showResultTally?<div className="px-6 my-2" style={{paddingLeft:isResultRoute?'0px':'1.5rem' , paddingRight:isResultRoute?'0px':'1.5rem' }}>
    <div className="flex items-center h-full mb-2">
        <div className="h-3 w-2 bg-customPoll mr-2"></div>
        <h2 className="font-bold font-devnagri text-2xl">रिजल्ट टैली</h2>
    </div>
  <div className={styles.electionResult}>
    <iframe
      title="loksabha exit poll"
      src={`https://electionresults.intoday.in/elections/2024/loksabha-elections/html/loksabha-result-tally-2024.html?site=uptak&v=${electionKeys.resultVersion}`}
    />
  </div>
</div>:<></>}</>
  );
};

export default ResultTally;
